<template>
	<div class="content">		
		<a-layout>
			<a-layout-content>
				<a-form :form="form" id="login" @submit="handleSubmit" class="login-form" :layout="'vertical'">
					<a-form-item style="text-align: center; padding: unset; margin-bottom: 5px;">
						<img src="../assets/Logo-Kurier-Color-Tribunal.png" style="width: 80%;" />
					</a-form-item>
					<a-form-item style="text-align: center; font-size: 28px; font-weight: bold; color: #1d375c;">
						<span v-if="primeiroAcesso == false" style="text-aling:left">FAÇA SEU LOGIN</span>
						<span v-else style="text-aling:left">Cadastre sua nova Senha</span>
					</a-form-item>
					<a-form-item v-if="primeiroAcesso==false" label="Login:" style="margin-left: 20px; margin-right: 20px;">
						<a-input
							style="text-align: left;"
							:maxLength=50
							placeholder="Login"
							v-decorator="['userName',{ rules: [{ required: false, message: 'Por favor, insira seu login!' }] }]"
							v-ant-input-focus
						>
							<a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)"/>
						</a-input>
					</a-form-item>
					<a-form-item v-else label="Nova Senha:" style="margin-left: 20px; margin-right: 20px;">
						<a-input-password
							ref='novaSenha'
							:maxLength=50
							style="text-align: left;"
							autoComplete="off"
							placeholder="Nova Senha"
							v-decorator="['NewPassword',{ rules: [{ required: false, message: 'Por favor, insira sua nova senha!' }] }]"							
							v-ant-input-focus
						>
							<a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
						</a-input-password>
					</a-form-item>					
					<div v-if="primeiroAcesso==false" style="z-index: 5; position: absolute; padding-left: 256px;">
						<a style="color: #798ce8; font-size: 13px;" @click="handleEsqueciMinhaSenha()">Esqueci minha senha</a>						
					</div>
					<a-form-item v-if="primeiroAcesso == false" label="Senha:" style="margin-left: 20px; margin-right: 20px;">
						<a-input-password
							ref='senha'
							:maxLength=50
							style="text-align: left;"
							autoComplete="off"
							v-decorator="['password',{ rules: [{ required: false, message: 'Por favor insira sua senha!' }] }]"							
							placeholder="Senha"
						>
							<a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
						</a-input-password>
					</a-form-item>					
					<a-form-item v-else label="Confirmação de Senha:" style="margin-left: 20px; margin-right: 20px;">
						<a-input-password
							ref='confNovaSenha'
							:maxLength=50
							style="text-align: left;"
							autoComplete="off"
							v-decorator="['confirmPassword',{ rules: [{ required: false, message: 'Por favor confirme sua senha!' }] }]"							
							placeholder="Confirmação de senha"
						>
							<a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)"/>
						</a-input-password>
					</a-form-item>
					<div class="row" v-if="!redeSegura">
						<div style="padding: 0px 0px 20px 15px;">
							<vue-recaptcha 
								:sitekey="siteKeyValue_V2"
								@verify="onCaptchaVerified_V2"
								@expired="onCaptchaExpired_V2"
							></vue-recaptcha>
						</div>
					</div>
					<a-form-item v-if="primeiroAcesso == false" style="text-align: right">
						<a-button type="primary" htmlType="submit"
							:disabled="!captchaVerified" 
							class="login-form-button">Entrar
						</a-button>
					</a-form-item>
					<a-form-item v-else style="text-align: right">
						<a-button type="primary" @click="atualizarSenha" 
							:disabled="!captchaVerified" 
							class="login-form-button">Salvar
						</a-button>						
					</a-form-item>
				</a-form>				
			</a-layout-content>
		</a-layout>

		<spinner v-if="loading" style="z-index: 999999;"/>

		<modal-component
			class="modal-component"
			title="Esqueceu a Senha"
			ref="modalEsqueciSenha"
			width="25%"
			:maskClosable="false"
		>
			<a-row style="margin-bottom: 15px;">
				<span style="font-size: 15.5px;">Informe seu login e enviaremos um e-mail para você com instruções.</span>
			</a-row>			
			<a-row>
				<a-input
					style="text-align: left;"
					:maxLength=50
					placeholder="Login"
					v-model="valueUsuarioEsqSenha"
					:allowClear="valueUsuarioEsqSenha!=''"
					v-ant-input-focus
				>
					<a-icon slot="prefix" type="user"/>
				</a-input>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" justify="space-between" align="middle">					
					<a-col :span="24" style="text-align: right;">					
						<a-button
							key="submit"
							type="primary"
							style="width: 120px;"
							@click.prevent="enviarEsqueciSenha()"
						>Enviar</a-button>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"
			title="Termo de Uso"
			ref="modalTermoUso"
			width="50%"
			:maskClosable="false"
		>			
			<a-row class="tr-linha-termo" style="height: calc(100vh - 550px); overflow-y: auto; min-height: 300px;">
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">						
						<span style="font-weight: 400; font-size: 15.5px;" v-html="textoTermo"/>
					</div>
				</a-col>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">							
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button
									key="submit"									
									style="width: 120px;"
									type="primary"										
									@click.prevent="atualizarStatusTermoUso(1)"
								>Aceito</a-button>
							</a-col>
							<a-col>
								<a-button key="back" style="width: 120px;" @click.prevent="atualizarStatusTermoUso(2)">Não Aceito</a-button>
							</a-col>								
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<Recaptcha />
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import { SET_TERMOACEITE } from "@/store/mutations";
import { DO_LOGIN, LOAD_TELAPERFISPORTAL, LOAD_MENU } from "@/store/actions";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import ModalComponent from "@/components/ModalComponent";
import Spinner from "@/components/LoadComponent";
import Helpers from "@/util/Helpers";
import { Promise } from 'q';
import { VueRecaptcha } from 'vue-recaptcha';
import Recaptcha from "@/components/Recaptcha.vue";

export default {
    name: "login",
    props: {
        error: {
            default: null
        }
    },
	data() {
		return {
			form: this.$form.createForm(this),
			textoTermo: '',
			user: {
				idUsuario: 0,
				login: '',
				senha: ''
			},
			loading: false,
			primeiroAcesso: false,
			auxPrimeiroAcesso: false,
			novaSenha: '',
			confirmacaoSenha: '',
			valueUsuarioEsqSenha: '',
			reducao: 550,
			captchaVerified: false,
      siteKeyValue_V2: process.env.VUE_APP_SITE_KEY_V2,
      reCaptchaToken_V3: null,
      siteKeyValue_V3: process.env.VUE_APP_SITE_KEY_V3,
      redeSegura: true
		};
  },
	beforeMount(){
    // this.$nextTick(() => {
    //   if (!localStorage.getItem('reloaded')) {
    //     localStorage.setItem('reloaded', 'true');
    //     window.location.reload(true);
    //   } else {
    //     localStorage.removeItem('reloaded');
    //   }
    // });

    this.$nextTick(() => {
      this.executarReCaptcha_V3();
    });
  },
	mounted() {		
		if (this.error) {
				showNotificationError(this, "Login", this.error);
		}
	},
	methods: {
		onCaptchaVerified_V2(response) {      
      this.captchaVerified = true;
    },
    onCaptchaExpired_V2() {
      this.captchaVerified = false;
    },
    executarReCaptcha_V3() {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(this.siteKeyValue_V3, { action: 'submit' }).then((token) => {
            this.reCaptchaToken = token;
            // Enviar o token ao servidor para validação
            this.enviarParaServidor(token);
          });
        });
      } else {
        this.captchaVerified = false;
				showNotificationError(this, "Login", 'reCAPTCHA não está disponível.');
        return;
      }
    },
    enviarParaServidor(token) {
      // Substitua esta parte pela lógica de envio ao servidor
      IntimacaoWebApi.reCaptchaSiteVerify(token)
      .then((res) => {				
        if (res.status === 200) {
          this.redeSegura = res.data.redeSegura;
          this.captchaVerified = this.redeSegura;					
        } else {
          this.captchaVerified = false;
          this.redeSegura = false;
        }
      })
      .catch((error) => {
				this.redeSegura = false;
				//showNotificationError(this, "Login", "Erro ao tentar .");
      });
    },
		async handleSubmit(e) {
			if (!this.captchaVerified) {
				showNotificationError(this, "Login", 'Por favor, complete o CAPTCHA');
        return;
      }

			this.loading = true;
			e.preventDefault();			
			this.user.login = this.form.getFieldValue("userName");
			this.user.senha = this.form.getFieldValue("password");

			//this.user.login = Helpers.limparCaracteres(this.form.getFieldValue("userName"));
			//this.user.senha = Helpers.limparCaracteres(this.form.getFieldValue("password"));

			//this.user.login = Helpers.criptografarFront(this.user.login);
			//this.user.senha = Helpers.criptografarFront(this.user.senha);

			this.$store
				.dispatch(DO_LOGIN, this.user)
				.then(res => {					
					if (res.codigo >= 1){
						showNotificationError(this, "Login", res.descricao);
						this.user.login = '';
						this.user.senha = '';
					} 
					else
					{						
						IntimacaoWebApi.recuperarTermo()
							.then(res => {								
								if (res.data.statusCode == 200) {
									let objTermoAceiteAdv = res.data.result.filter(f => {
										return f.tipoTermo == 'TERMOACEITE_ADV'
									});
									let objTermoAceiteRep = res.data.result.filter(f => {
										return f.tipoTermo == 'TERMOACEITE_REP'
									});
									let objTermoUso = res.data.result.filter(f => {
										return f.tipoTermo == 'TERMOUSO'
									});

									this.textoTermo = objTermoUso[0].conteudoPortal;
									this.$store.commit(SET_TERMOACEITE, {termoAceiteAdv: objTermoAceiteAdv[0].conteudoPortal, termoAceiteRep: objTermoAceiteRep[0].conteudoPortal});
								}
								else
								{
									this.primeiroAcesso = false;
									this.user.idUsuario = 0;
									this.user.login = '';
									this.user.senha = '';
									this.$router.replace({ name: "login" });
									showNotificationError(this, "Login", res.data.errorMessage);
								}
							})
							.catch(res => {
								this.primeiroAcesso = false;
								this.user.idUsuario = 0;
								this.user.login = '';
								this.user.senha = '';
								this.$router.replace({ name: "login" });
								showNotificationError(this, "Login", "Erro ao tentar tentar recuperar termo.");
							});

						this.user.idUsuario = res.idUsuario;
						if (res.statusTermoUso == 1)
						{
							this.primeiroAcesso = res.primeiroAcesso;
							if (this.primeiroAcesso == false){
								Promise.all([this.carregarPerfilPortal(), this.carregarMenu()]).then(r => {
									this.$router.replace({ name: "home" });
								});
							}
							else
							{	
								this.user.login = '';
								this.user.senha = '';
							}							
						}
						else
						{
							this.auxPrimeiroAcesso = res.primeiroAcesso;
							this.$refs.modalTermoUso.showModal();						
						}
					}

					if (this.$refs.senha != undefined)
						this.$refs.senha.visible = false;
					if (this.$refs.novaSenha != undefined)
						this.$refs.novaSenha.visible = false;
					if (this.$refs.confNovaSenha != undefined)					
						this.$refs.confNovaSenha.visible = false;
				})
				.catch(error => {
					if (error.response){
						if (error.response.data)
							showNotificationError(this, "Login", error.response.data.error_description);
						else
							showNotificationError(this, "Login", "Erro ao tentar realizar login.");
					} else {
						if (error.errors["Login"] != undefined) {						
							showNotificationError(this, "Login", "Login: " + error.errors["Login"][0]);
							return;
						}
						if (error.errors["Senha"] != undefined) {
							showNotificationError(this, "Login", "Senha: " + error.errors["Senha"][0]);
							return;
						}
						showNotificationError(this, "Login", error.title);
					}
				})
				.then(() => {					
					this.loading = false;
				});
		},
		async atualizarSenha(){
			this.loading = true;
			this.novaSenha = Helpers.limparCaracteres(this.form.getFieldValue("NewPassword"));
			this.confirmacaoSenha = Helpers.limparCaracteres(this.form.getFieldValue("confirmPassword"));

			if (this.novaSenha.toLowerCase() != this.confirmacaoSenha.toLowerCase()){
				showNotificationError(this, "Erro", "As senhas informadas não combinam!");
				this.loading = false; 
				return;
			}

			IntimacaoWebApi.atualizarSenha(this.user.idUsuario, this.novaSenha)
				.then(res => {
					Promise.all([this.carregarPerfilPortal(), this.carregarMenu()]).then(r => {
						this.$router.replace({ name: "home" });
					});
					this.loading = false;
				})
				.catch(error => {
					if (error.response){
						if (error.response.data)
							showNotificationError(this, "Login", error.response.data.error_description);
						else
							showNotificationError(this, "Login", "Erro ao tentar realizar login.");
					} else {
						showNotificationError(this, "Login", error.error_description);
					}
					this.loading = false;
				});
		},
		async carregarPerfilPortal() {
			return this.$store
				.dispatch(LOAD_TELAPERFISPORTAL)
				// .then()
				.catch(erro => {
					showNotificationError(this, "Login", "Erro ao tentar carregar lista de telaperfilPortal.");
				});
		},
		async carregarMenu() {
			return this.$store
				.dispatch(LOAD_MENU, this.$store)
				// .then()
				.catch(erro => {
					showNotificationError(this, "Login", "Erro ao tentar carregar lista de menu.");
				});
		},
		handleEsqueciMinhaSenha() {
			this.valueUsuarioEsqSenha = '';
			this.$refs.modalEsqueciSenha.showModal();			
		},
		enviarEsqueciSenha(){
			if (this.valueUsuarioEsqSenha.trim() == '')
			{
				showNotificationError(this, "Login", "Login é um campo obrigatório.");
				return;
			}
			IntimacaoWebApi.esqueciMinhaSenha(this.valueUsuarioEsqSenha.trim())
				.then(res => {
					this.$refs.modalEsqueciSenha.handleCancel();
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Login", res.data.result);
					} else
						showNotificationError(this, "Login", res.data.errorMessage);
				})
				.catch(res => {
					this.$refs.modalEsqueciSenha.handleCancel();
					showNotificationError(this, "Login", "Erro ao tentar enviar e-mail.");
				});
		},
		atualizarStatusTermoUso(statusTermoUso){
			this.loading = true;
			IntimacaoWebApi.atualizarStatusTermoUso(this.user.idUsuario, statusTermoUso)
				.then(res => {
					this.loading = false;
					this.$refs.modalTermoUso.handleCancel();					
					if (statusTermoUso == 1)
					{
						this.primeiroAcesso = this.auxPrimeiroAcesso;
						if (this.primeiroAcesso == false){
							Promise.all([this.carregarPerfilPortal(), this.carregarMenu()]).then(r => {
								this.$router.replace({ name: "home" });
							});
						}
						else
						{	
							this.user.login = '';
							this.user.senha = '';
						}
					} 
					else 
					{
						this.primeiroAcesso = false;
						this.user.idUsuario = 0;
						this.user.login = '';
						this.user.senha = '';
						this.$router.replace({ name: "login" });
					}
				})
				.catch(error => {
					this.$refs.modalTermoUso.handleCancel();
					this.primeiroAcesso = false;
					this.user.idUsuario = 0;
					this.user.login = '';
					this.user.senha = '';
					this.$router.replace({ name: "login" });
					if (error.response){
						if (error.response.data)
							showNotificationError(this, "Login", error.response.data.error_description);
						else
							showNotificationError(this, "Login", "Erro ao tentar realizar login.");
					} else {
						showNotificationError(this, "Login", error.error_description);
					}
					this.loading = false;
				});
		},
	},
	components: { Spinner, ModalComponent, VueRecaptcha, Recaptcha }
};
</script>

<style scoped>
.content {
	height: 100%;
}

.ant-layout {
	height: 100%;
	background: none;
}

.ant-layout-content {
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	background: none;
}

.ant-layout-footer {
	position: absolute;
	bottom: 0;
	width: 100%;
}

div .content::after {
	content: "";
	background: url("../assets/tribunalbg.jpg") no-repeat center center fixed;
	background-color: gray;
	background-size: cover;
	opacity: 0.9;
	-moz-opacity: 0.9;
	filter: alpha(opacity=90);
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	position: absolute;
	z-index: -1;
}

#login {
	width: 450px;
	background: #fff;
	padding: 20px;
	border-radius: 2%;
	border-width: 1.5px;
    border-color: #d9d9d9;
    border-style: solid;
}

#login .login-form {
	width: 100%;
}

#login .login-form-forgot {
	float: right;
}

#login .login-form-button {
	width: 30%;
}

/* @media screen and (max-height: 970px){
	.tr-linha-termo {
		height: calc(100vh - 550px);		
	}
}

@media screen and (max-height: 870px){
	.tr-linha-termo {
		height: calc(100vh - 470px);
	}
}

@media screen and (max-height: 770px){
	.tr-linha-termo {
		height: calc(100vh - 410px);
	}
}

@media screen and (max-height: 670px){
	.tr-linha-termo {
		height: calc(100vh - 380px);
	}
}

@media screen and (max-height: 570px){
	.tr-linha-termo {
		height: calc(100vh - 350px);
	}
} */
</style>

<style>
.ant-form label {    
    color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
	font-size: 15px;
}
</style>
